import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { Box, ButtonStyled, HeadingStyled } from "../../../styled/Elements";
import {
  CancelWithBg,
  LeftArrowBlack,
  RightArrowWhite,
  RightArrowWithoutBar,
} from "../../../styled/AllImages";
import ValidatedInput from "../../../common/inputFields/ValidatedInput";
import { useEffect, useState } from "react";
import CategoriesApi from "../../../../services/api/categoriesApi";
import { toast } from "react-toastify";

const EditCategoryModal = ({
  show,
  onHide,
  title,
  categoryData,
  getCategoriesList,
  activePage,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
  };

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      action: "update",
      product_category_id: categoryData && categoryData.id,
    };
    try {
      setLoading(true);
      const { code } = await CategoriesApi.createCategory(updatedData);
      if (code === 200) {
        reset();
        onHide();
        toast.success(t("category_edited_successfully"));
        getCategoriesList(activePage);
        dispatchEvent(new Event("productCategoryUpdated"))
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (categoryData) {
      setValue("name_en", categoryData.name_en || "");
      setValue("name_ar", categoryData.name_ar || "");
    }
  }, [categoryData, setValue]);

  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <SelectUserModalWrapper>
        <Box className="">
          <Box className="d-flex justify-content-between align-items-center border-bottom mb-4 p-4">
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {title}
            </HeadingStyled>
            <CancelWithBg
              className="cursor-pointer"
              style={{ height: "33px", width: "33px" }}
              onClick={onHide}
            />
          </Box>
        </Box>
      </SelectUserModalWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="paddingExceptTop">
          <ValidatedInput
            start="start"
            column="column"
            weight="600"
            name="name_en"
            type="input"
            fieldType="text"
            placeholder="name_en"
            label="name_en"
            className="combined px-0"
            // staric="staric"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
          <ValidatedInput
            start="start"
            column="column"
            weight="600"
            name="name_ar"
            type="input"
            fieldType="text"
            placeholder="name_ar"
            label="name_ar"
            className="combined px-0"
            // staric="staric"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box>
        <Box className="modal-footer">
          <ButtonStyled
            border="var(--borderExtraLight)"
            iconBefore={LeftArrowBlack}
            bg="transparent"
            label={t("Cancel")}
            color="var(--text)"
            type="button"
            onClick={() => {
              onHide();
            }}
          ></ButtonStyled>
          <ButtonStyled
            bg="var(--themeColor)"
            label={t("update")}
            type="submit"
            icon={RightArrowWhite}
            isLoading={loading}
          ></ButtonStyled>
        </Box>
      </Form>
    </Modal>
  );
};

export default EditCategoryModal;

const SelectUserModalWrapper = styled.div``;
